import { Type as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';

export type Type = {
  id: string;
  name: string;
};

export const fromGql = (item: GQLItem): Type =>
  take(item, 'id', 'name') as Type;
